// extracted by mini-css-extract-plugin
module.exports = {"privacy_policy":"PrivacyPolicy_privacy_policy__G6aS3","table_content":"PrivacyPolicy_table_content__9NYtV"};